<template>
  <div>
    <div id="AgendaDeAudiencias_div" class="w-100 px-5 py-4">
      <div id="TituloAgendaDeAudiencias_div">
        <h1 style="margin-bottom: 0px;">AGENDA DE AUDIENCIAS</h1>
        <h3 style="margin-top: 0px;">Calendario para el registro de audiencias</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaEventosCalendario"></FiltrosDeBusqueda>
          </div>
        </div>
        <div id="CalendarioAgendaDeAudiencias_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Calendario de audiencias</h4>
            <h6>Seleccione una fecha para agendar la audiencia</h6>
            <hr />
            <full-calendar :events="eventosFullCalendar" :config="configuracionFullCalendar"></full-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import sistemas from '@/../static/js/sistemas'
  import FullCalendar from '@/../static/js/fullcalendar'
  import RouterForseti from '@/router/index'
  import api from '@/../static/js/api'
  import axios from 'axios'  

  export default {
    components: {
      RouterForseti,
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda,
      FullCalendar
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo }, //verificar si es necesario
          //{ catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        funcionActivacion: "cargaEventosCalendario()",
        eventosFullCalendar: [],
        configuracionFullCalendar: {
          slotLabelFormat: 'h:mma',
          header: {
            left: 'prev,today,next',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,list'
          },
          defaultView: 'agendaWeek',
          editable: false,
          eventMouseover: function (data, event, view) {
                                    
            var tooltip = '<div class="tooltiptopicevent" style="width:auto;height:auto;background:#212529;position:absolute;z-index:10001;padding:10px 10px 10px 10px ;  line-height: 200%;">' + 'Audiencia: <br/>' + data.description + '</div>';


            $("body").append(tooltip);
            $(this).mouseover(function (e) {
                $(this).css('z-index', 10000);
                $('.tooltiptopicevent').fadeIn('500');
                $('.tooltiptopicevent').fadeTo('10', 1.9);
            }).mousemove(function (e) {
                $('.tooltiptopicevent').css('top', e.pageY + 10);
                $('.tooltiptopicevent').css('left', e.pageX + 20);
            });

          },
          eventMouseout: function (data, event, view) {
              $(this).css('z-index', 8);

              $('.tooltiptopicevent').remove();

          },
          eventClick: function (calEvent, jsEvent, view) {
            $(this).css('z-index', 8);
            $('.tooltiptopicevent').remove();

            let accion = calEvent.BaseDatosId == enumeraciones.basesDeDatos.Forseti ? enumeraciones.acciones.Cambios : enumeraciones.acciones.Alta;

            RouterForseti.push({
              name: 'AgendarAudiencia', params: {
                FechaAgenda: calEvent.start,
                AudienciaId: calEvent.id,
                BaseDeDatosProvenienteId: calEvent.BaseDatosId,
                AccionId: accion
              }
            });
          },
          select: function (start, end, timezone, callback) {
            RouterForseti.push({
              name: 'AgendarAudiencia', params: {
                FechaAgenda: start,
                AccionId: enumeraciones.acciones.Alta
              }
            });
          }
        },
      }
    },
    methods: {
      cargaEventosCalendario: function () {
        comun.SeEstaCargandoInformacion(true);
        let peticion = {
          FechaInicial: this.$store.state.Comun_FechaInicial,
          FechaFinal: this.$store.state.Comun_FechaFinal,
          PartidoJudicialId: this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'],
          MateriaId: this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'],
          JuzgadoId: this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'],          
          EsPrueba: this.enumeraciones.EsPrueba
        }

        axios.post(api.conexion + api.Forseti.sistema.audiencias.agenda.ObtenerEventosCalendario,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            console.log(respuesta);
          } else {
            this.eventosFullCalendar = respuesta.data.EventosCalendario;
          }
          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor" + e);
          });
      },
    },
    created() {
      this.cargaEventosCalendario();
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  .fc-view-container {
    background-color: #f6f6f6;
    color: #343a40;
    border-color: #212529 !important;
  }

  .fc-view table {
    border-color: #212529 !important;
  }

  .fc-axis {
    background-color: #504f54;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  }

  .fc-day-header {
    background-color: #212529 !important;
    color: white;
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    padding: .75rem !important;
  }

  .fc-button {
    background-color: whitesmoke !important;
    border: none !important;
    padding: .375rem 1.35rem !important;
    color: #212529 !important;
    display: inline-block !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    font-size: 1rem !important;
    border-radius: .25rem !important;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out !important;
  }

  .fc-today {
    background-color: #f2f2f2 !important;
    color: #212529 !important;
  }

  .fc-event {
    background-color: #212529;
    border-color: #32383e;
    color: white !important;
    padding: .375rem .375rem !important;
    font-size: .75rem !important;
    border-radius: .25rem !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/AgendaDeAudiencias/AgendaDeAudiencias.vue